import { getKeyHandler } from 't-lib-ui/structure';
import './LegalFooter.css';

// Always-available Terms of Service / Privacy Policy line plus a one-line support contact,
// shown at the bottom of the Home and Account pages. `tight` reduces the (otherwise generous) top gap — used for the short new-user
// HomePage, where the footer is already in view rather than far below scrolled content.
// `bottom` makes the footer drop to the bottom of its container on short pages (and flow right
// after the content on long ones); it only works when the footer's host is a flex column that
// fills the available height (see `.legalFooter.bottom` and the host containers in the page CSS).
// The links are flowFocussable, so they must be rendered inside a <FlowForm> for keyboard nav.
// They point at the static legal pages on the marketing site (sites/downread), not app routes.
const LegalFooter: React.FC<{ tight?: boolean; bottom?: boolean }> = ({ tight, bottom }) => (
  <p className={`legalFooter${tight ? ' tight' : ''}${bottom ? ' bottom' : ''}`}>
    By using Downread you agree to our{' '}
    <a className="legalFooterLink flowFocussable" tabIndex={0} href="https://downread.com/terms.html"
      onKeyDown={getKeyHandler(() => { window.location.href = 'https://downread.com/terms.html'; })}>Terms of Service</a> and{' '}
    <a className="legalFooterLink flowFocussable sidewayFocus" tabIndex={0} href="https://downread.com/privacy.html"
      onKeyDown={getKeyHandler(() => { window.location.href = 'https://downread.com/privacy.html'; })}>Privacy Policy</a>.{' '}
    <a className="legalFooterLink flowFocussable sidewayFocus" tabIndex={0} href="https://downread.com/legal-notice.html"
      onKeyDown={getKeyHandler(() => { window.location.href = 'https://downread.com/legal-notice.html'; })}>Legal Notice</a> (Impressum).
    <span className="legalFooterFeeds">
      Feeds are provided by third parties and remain subject to their own terms and copyright.
    </span>
    <span className="legalFooterFeeds">
      Questions? Write to{' '}
      <a className="legalFooterLink flowFocussable sidewayFocus" tabIndex={0} href="mailto:support@downread.com"
        onKeyDown={getKeyHandler(() => { window.location.href = 'mailto:support@downread.com'; })}>support@downread.com</a>.
    </span>
  </p>
);

export default LegalFooter;
